(function () {
  function activatePanel(root, index) {
    var triggers = root.querySelectorAll('[data-ha-collection-megamenu-trigger]');
    var panels = root.querySelectorAll('[data-ha-collection-megamenu-panel]');

    triggers.forEach(function (trigger) {
      var isActive = trigger.getAttribute('data-ha-collection-megamenu-trigger') === String(index);
      trigger.classList.toggle('is-active', isActive);
    });

    panels.forEach(function (panel) {
      var isActive = panel.getAttribute('data-ha-collection-megamenu-panel') === String(index);
      panel.classList.toggle('is-active', isActive);
    });
  }

  function initMegamenu(root) {
    if (root.dataset.haCollectionMegamenuInit === 'true') return;
    root.dataset.haCollectionMegamenuInit = 'true';

    var triggers = root.querySelectorAll('[data-ha-collection-megamenu-trigger]');
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      trigger.addEventListener('mouseenter', function () {
        activatePanel(root, trigger.getAttribute('data-ha-collection-megamenu-trigger'));
      });

      trigger.addEventListener('focus', function () {
        activatePanel(root, trigger.getAttribute('data-ha-collection-megamenu-trigger'));
      });
    });

    var dropdown = root.closest('.yv-dropdown-detail');
    if (dropdown) {
      dropdown.addEventListener('mouseenter', function () {
        var activeTrigger = root.querySelector('[data-ha-collection-megamenu-trigger].is-active');
        if (!activeTrigger) {
          activatePanel(root, triggers[0].getAttribute('data-ha-collection-megamenu-trigger'));
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-ha-collection-megamenu]').forEach(initMegamenu);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
